import { SvgIcon, SvgIconProps } from '@mui/material';
import * as React from 'react';

const Leaderboard: React.FunctionComponent<SvgIconProps> = React.memo((props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path d="M2.08333 15C2.08333 14.4477 2.49374 14 3 14H6.66667C7.17293 14 7.58333 14.4477 7.58333 15L7.5 21C7.5 21.5523 7.08959 22 6.58333 22H2.91667C2.41041 22 2 21.5523 2 21L2.08333 15Z" />
      <path d="M9.25 11.437C9.25 10.9066 9.66041 10.4767 10.1667 10.4767H13.8333C14.3396 10.4767 14.75 10.9066 14.75 11.437V21.0397C14.75 21.5701 14.3396 22 13.8333 22H10.1667C9.66041 22 9.25 21.5701 9.25 21.0397V11.437Z" />
      <path d="M22 21.0296C22 21.5655 21.5896 22 21.0833 22H17.4167C16.9104 22 16.5 21.5655 16.5 21.0296L16.5 13C16.5 12.464 16.9104 12.0296 17.4167 12.0296H21.0833C21.5896 12.0296 22 12.464 22 13V21.0296Z" />
      <path d="M12 7.73036L13.6592 8.78042C13.9631 8.97286 14.3349 8.68838 14.255 8.3286L13.8152 6.35399L15.2825 5.02363C15.5504 4.78099 15.4065 4.3208 15.0546 4.29152L13.1235 4.11999L12.3678 2.25415C12.2319 1.91528 11.7681 1.91528 11.6322 2.25415L10.8765 4.11581L8.94538 4.28733C8.59354 4.31662 8.44961 4.7768 8.71749 5.01945L10.1848 6.3498L9.74502 8.32442C9.66506 8.6842 10.0369 8.96868 10.3408 8.77624L12 7.73036Z" />
    </SvgIcon>
  );
});

export default Leaderboard;
